<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper">
        <q-select ref="field"
                  v-model="inputValue"
                  :clearable="clearable"
                  :filter="filter"
                  autofocus-filter
                  :filter-placeholder="`${$T('type to search')} (${itemsAvailable})`"
                  :name="path"
                  :dusk="path"
                  :float-label="processedLabel"
                  :options="filteredOptions"
                  :color="color"
                  :disable="form.busy || disable"
                  @termsChanged="(terms) => this.terms = terms"
                  @input="onInput"></q-select>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import Fuse from 'fuse.js'
    import {QSelect} from 'quasar-framework'

    // Add a watcher to QSelect component on "created" event. This watcher emits a "termsChanged" event when
    // the internal var "terms" changes allowing us to hook on that event and sync our local "terms" var
    QSelect.created = function () {
        this.$watch('terms', (newVal) => {
            this.$emit('termsChanged', newVal)
        })
    }

    export default {
        name: 'VAutocompleteList',

        mixins,

        props: {
            options: {
                type: Array,
                required: true
            },
            itemPlural: String,
            top: {
                type: Number,
                default: 5
            },
            autoSelect: Boolean,
            fuseConfig: {
                type: Object,
                default() {
                    return {
                        shouldSort: true,
                        tokenize: true,
                        findAllMatches: true,
                        threshold: 0.3,
                        location: 0,
                        distance: 20,
                        maxPatternLength: 32,
                        minMatchCharLength: 0,
                        keys: [
                            'label',

                        ]
                    }
                }
            },
            limitResult: Number,
        },

        components: {
            QSelect
        },

        data() {
            return {
                fuse: new Fuse(this.options, this.fuseConfig),
                terms: ''
            }
        },

        watch: {
            options(newOptions) {
                this.fuse = new Fuse(newOptions, this.fuseConfig)
                this.selectOnlyOption()
            }
        },

        mounted() {
            this.selectOnlyOption()
        },

        computed: {
            filteredOptions() {
                let limit = this.limitResult ? {limit: this.limitResult} : {}
                var results = this.fuse.search(this.terms, limit)
                if (!this.terms && this.top > 0)
                    results = this.topOptions
                this.$nextTick(() => this.$refs.field.reposition())
                return this.addSelectedTo(results)
            },

            topOptions() {
                return [{value: '#', label: this.$T('frequent options:'), disable: true}]
                    .concat(this.options.slice(0, this.top))
            },

            itemsAvailable() {
                var items = this.itemPlural ? this.itemPlural : this.$t('items')
                return `${this.options.length} ${items} ${this.$t('available_plural')}`
            }
        },

        methods: {
            filter: () => (true),

            addSelectedTo(options) {
                if (!options.find(opt => opt.value == this.value) && this.value){
                    let filterOptions = this.options.find(opt => opt.value == this.value)

                    if(filterOptions)
                        return [filterOptions].concat(options)
                }
                return options
            },

            selectOnlyOption() {
                if (this.options.length != 1 || !this.autoSelect) return
                this.inputValue = this.options[0].value
                this.onInput()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VAutocompleteList.vue